import { gql } from '@apollo/client';

export const PORTALIO_AUTH_DETAILS_FRAGMENT = gql`
  fragment PortalioAuthDetails on PortalioAuthDetails {
    id
    userId
    portalioUserName
  }
`;

export const PORTALIO_PROJECT_IMPORT_DETAILS = gql`
  fragment PortalioProjectImportDetails on ExternalProjectImportPreview {
    id
    address
    addressId
    projectName
    created {
      name
      entity
    }
    updated {
      name
      entity
      diffs {
        field
        newValue
        oldValue
      }
    }
  }
`;
